import { createAction } from 'redux-actions';
import { ExecuteRothConversionActionTypes as act } from './actionTypes';
import { ExecuteRothConversionState } from './types';
import { callApi, getEndpoint } from '../../../utils/api';
import { createRothConversionTransaction } from './rothConversion.helper';
import { analyticsDataLayer } from '../../utils/analytics-helper';
export * from './actions';

const initialState: ExecuteRothConversionState = {
  execute: false,
  isLoaded: false,
  isLoading: false,
  hasFailed: false,
  validationFailed: false,
  transactions: [],
  rothConversionTradeDates: {},
  isRothConversionTradeDatesLoaded: false,
  isRothConversionTradeDatesLoading: false,
  hasRothConversionTradeDatesFailed: false,
};

export default function executeRothConversion(
  state = initialState,
  { payload, type }
) {
  switch (type) {
    case act.EXECUTE_ROTH_CONFIRMATION:
      const { execute, transactions } = payload;
      return {
        ...state,
        execute,
        transactions,
      };

    case `${act.EXECUTE_ROTH_CONVERSION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
        transactions: [],
      };

    case `${act.EXECUTE_ROTH_CONVERSION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        confirmationNumber: payload.body.confirmationNumber,
        validationFailed: payload.body.validationFailed,
        success: payload.body.success,
        tradeDate: payload.body.tradeDate,
        hasFailed: false,
        transactions: payload.body.transactions || [{}],
      };

    case `${act.EXECUTE_ROTH_CONVERSION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: payload.body,
        hasFailed: true,
      };
    case `${act.ROTH_CONVERSION_TRADE_DATES}_PENDING`:
      return {
        ...state,
        rothConversionTradeDates: {},
        isRothConversionTradeDatesLoaded: false,
        isRothConversionTradeDatesLoading: true,
        hasRothConversionTradeDatesFailed: false,
      };

    case `${act.ROTH_CONVERSION_TRADE_DATES}_FULFILLED`:
      return {
        ...state,
        rothConversionTradeDates: payload.body,
        isRothConversionTradeDatesLoaded: true,
        isRothConversionTradeDatesLoading: false,
        hasRothConversionTradeDatesFailed: false,
      };

    case `${act.ROTH_CONVERSION_TRADE_DATES}_REJECTED`:
      return {
        ...state,
        rothConversionTradeDates: {},
        isRothConversionTradeDatesLoaded: false,
        isRothConversionTradeDatesLoading: false,
        hasRothConversionTradeDatesFailed: true,
      };
    default:
      return state;
  }
}

export const getRothConversionTradeDates = (payload) => {
  return (dispatch) => {
    const action = createAction(act.ROTH_CONVERSION_TRADE_DATES)(
      callApi(
        getEndpoint('rothConversionValidate'),
        { method: 'POST' },
        payload
      )
    );
    dispatch(action);
  };
};

export const submitRothConversion = ({
  convertFromFunds,
  allocateToFunds,
  taxPercentage,
  beneficiaries,
  beneficiaryOption,
  userAddedBeneficiaries,
}) => {
  const payload = createRothConversionTransaction({
    convertFromFunds,
    allocateToFunds,
    taxPercentage,
    beneficiaries,
    beneficiaryOption,
    userAddedBeneficiaries,
  });
  try {
    const getAnalyticsDataForTransaction = (payload) => {
      const { fromRecords, toRecords } = payload;
      const fundAmounts = fromRecords.map((fundAmount) => fundAmount.amount);
      const reducer = (a, b) => a + b;
      const amount = fundAmounts.reduce(reducer);
      const quantity = fromRecords.length;
      let accountTypes = [];
      fromRecords.forEach((tr) => {
        const { sourcePositionKey } = tr;
        if (sourcePositionKey) {
          const {
            agreementKey: {
              productType: { enumerationName },
            },
          } = sourcePositionKey;
          if (enumerationName) {
            accountTypes = accountTypes.concat(enumerationName);
          }
        }
      });
      toRecords.forEach((tr) => {
        const { sourcePositionKey } = tr;
        if (sourcePositionKey) {
          const {
            agreementKey: {
              productType: { enumerationName },
            },
          } = sourcePositionKey;
          if (enumerationName) {
            accountTypes = accountTypes.concat(enumerationName);
          }
        }
      });
      return { amount, quantity, accountTypes };
    };

    analyticsDataLayer({
      ...getAnalyticsDataForTransaction(payload),
    });
  } catch (e) {
    // don't let analytics errors cause other things to fail
  }
  return (dispatch) => {
    const action = createAction(act.EXECUTE_ROTH_CONVERSION)(
      callApi(getEndpoint('executeRothConversion'), { method: 'POST' }, payload)
    );
    dispatch(action);
  };
};
